import { types } from '../actions/types';

export const FAQReducer = (
  state = {
    get: null,
    create: null,
    update: null,
    deleteById: null,
  },
  action,
) => {
  switch (action.type) {
    case types.faqGetFAQs:
      return { ...state, get: action.payload };
    case types.faqCreateFAQ:
      return { ...state, create: action.payload };
    case types.faqUpdateFAQ:
      return { ...state, update: action.payload };
    case types.faqDeleteFAQById:
      return { ...state, deleteById: action.payload };
    default:
      return state;
  }
};
